import {
    useEffect,
    useState,
} from 'react';

import api from '../../api/api';
import { IMAGE_URL } from '../../path';
import AdminLayout from './Components/AdminLayout';

export default function AdminLetsCook()
{
    const [headerPreview, setHeaderPreview] =
        useState('');

    const [productPreview, setProductPreview] =
        useState('');

    const [cuisinePreview, setCuisinePreview] =
        useState('');

    const [headerImage, setHeaderImage] =
        useState<File | null>(null);

    const [productImage, setProductImage] =
        useState<File | null>(null);

    const [cuisineImage, setCuisineImage] =
        useState<File | null>(null);

    const [saving, setSaving] =
        useState(false);

    useEffect(() => {

        loadPage();

    }, []);

    const getImageUrl = (
        path?: string
    ) => {

        if (!path) {
            return '';
        }

        if (
            path.startsWith(
                'http'
            )
        ) {
            return path;
        }

        return `${IMAGE_URL}${path}`;

    };

    const loadPage = async () => {

        try {

            const [
                headerResponse,
                productResponse,
                cuisineResponse
            ] = await Promise.all([

                api.get(
                    '/page-header/lets-cook'
                ),

                api.get(
                    '/page-header/lets-cook-product'
                ),

                api.get(
                    '/page-header/lets-cook-cuisine'
                ),

            ]);

            if (
                headerResponse.data.page?.cover_image
            ) {

                setHeaderPreview(
                    getImageUrl(
                        headerResponse.data.page.cover_image
                    )
                );

            }

            if (
                productResponse.data.page?.cover_image
            ) {

                setProductPreview(
                    getImageUrl(
                        productResponse.data.page.cover_image
                    )
                );

            }

            if (
                cuisineResponse.data.page?.cover_image
            ) {

                setCuisinePreview(
                    getImageUrl(
                        cuisineResponse.data.page.cover_image
                    )
                );

            }

        } catch (
            error
            ) {

            console.error(
                error
            );

        }

    };

    const validateImage = (
        file: File
    ) => {

        if (
            file.size >
            2 * 1024 * 1024
        ) {

            alert(
                'Image must be 2MB or smaller.'
            );

            return false;

        }

        return true;

    };

    const handleSave = async () => {

        try {

            setSaving(
                true
            );

            if (
                headerImage
            ) {

                const formData =
                    new FormData();

                formData.append(
                    'image',
                    headerImage
                );

                await api.post(
                    '/page-header/lets-cook/cover-image',
                    formData
                );

            }

            if (
                productImage
            ) {

                const formData =
                    new FormData();

                formData.append(
                    'image',
                    productImage
                );

                await api.post(
                    '/page-header/lets-cook-product/cover-image',
                    formData
                );

            }

            if (
                cuisineImage
            ) {

                const formData =
                    new FormData();

                formData.append(
                    'image',
                    cuisineImage
                );

                await api.post(
                    '/page-header/lets-cook-cuisine/cover-image',
                    formData
                );

            }

            await loadPage();

            setHeaderImage(
                null
            );

            setProductImage(
                null
            );

            setCuisineImage(
                null
            );

            alert(
                'Lets Cook page updated successfully.'
            );

        } catch (
            error
            ) {

            console.error(
                error
            );

            alert(
                'Failed to save changes.'
            );

        } finally {

            setSaving(
                false
            );

        }

    };

    return (

        <AdminLayout>

            <div className="page-header">

                <h1>
                    Lets Cook Page
                </h1>

                <button
                    className="action-btn"
                    onClick={
                        handleSave
                    }
                    disabled={
                        saving
                    }
                >
                    {
                        saving
                            ? 'Saving...'
                            : 'Save Changes'
                    }
                </button>

            </div>

            <div className="admin-card">

                <h2>
                    Lets Cook Header Image
                </h2>

                {
                    headerPreview && (

                        <img
                            src={
                                headerPreview
                            }
                            alt=""
                            className="image-preview"
                        />

                    )
                }

                <p className="field-hint">
                    Maximum file size: 2MB
                </p>

                <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => {

                        const file =
                            e.target.files?.[0];

                        if (
                            !file
                        ) {
                            return;
                        }

                        if (
                            !validateImage(
                                file
                            )
                        ) {
                            return;
                        }

                        setHeaderImage(
                            file
                        );

                        setHeaderPreview(
                            URL.createObjectURL(
                                file
                            )
                        );

                    }}
                />

            </div>

            <div className="admin-card">

                <h2>
                    Cook By Product Header Image
                </h2>

                {
                    productPreview && (

                        <img
                            src={
                                productPreview
                            }
                            alt=""
                            className="image-preview"
                        />

                    )
                }

                <p className="field-hint">
                    Maximum file size: 2MB
                </p>

                <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => {

                        const file =
                            e.target.files?.[0];

                        if (
                            !file
                        ) {
                            return;
                        }

                        if (
                            !validateImage(
                                file
                            )
                        ) {
                            return;
                        }

                        setProductImage(
                            file
                        );

                        setProductPreview(
                            URL.createObjectURL(
                                file
                            )
                        );

                    }}
                />

            </div>

            <div className="admin-card">

                <h2>
                    Cook By Cuisine Header Image
                </h2>

                {
                    cuisinePreview && (

                        <img
                            src={
                                cuisinePreview
                            }
                            alt=""
                            className="image-preview"
                        />

                    )
                }

                <p className="field-hint">
                    Maximum file size: 2MB
                </p>

                <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => {

                        const file =
                            e.target.files?.[0];

                        if (
                            !file
                        ) {
                            return;
                        }

                        if (
                            !validateImage(
                                file
                            )
                        ) {
                            return;
                        }

                        setCuisineImage(
                            file
                        );

                        setCuisinePreview(
                            URL.createObjectURL(
                                file
                            )
                        );

                    }}
                />

            </div>

        </AdminLayout>

    );

}
